import { useEffect, useState } from 'react';
import serviceBanner from '../../../assets/images/service_banner.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BannerData } from '../../../types/common.type';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { bannersUrl } from '../../../utils/demoData';
import { Card } from '@mui/material';
import CommonServices from '../../../services/common.services';
// import CommonServices from '../../../services/common.services';

export function ServiceBannerCarousel() {
  const [images, setImages] = useState<BannerData[]>([]);
  const [loading, setLoading] = useState(true);
  var settings = {
    // dots: true,
    infinite: true,
    speed: 1000,
    // slidesToShow: 1,
    // slidesToScroll: 1,
  };
  const token = useSelector((state: RootState) => state.auth.token);

  const getBannerImages = async () => {
    try {
      const images = await CommonServices.getBannerImagesAsync('', 'BANNER', 'CAROUSEL');
      setImages([...images]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBannerImages();
    // eslint-disable-next-line
  }, [token]);

  if (!images?.length && !loading)
    return <img alt="banner" className="w-full object-contain" src={serviceBanner} />;

  return (
    <div
      className="bg-transparent w-full h-[45vw] overflow-hidden rounded-xl shadow-md "
      onClick={() => window.open('https://www.ifbappliances.com/', '_blank')}
    >
      <Slider {...settings} autoplay={true}>
        {images.map((_image, index) => {
          return (
            <div className="w-full h-[45vw] overflow-hidden" key={index}>
              <img
                alt="banner"
                className="w-full h-full object-contain object-center rounded-lg"
                src={_image.imgUrl}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export function Banner({ name, source }: { name: string; source?: any }) {
  return (
    <Card>
      <img alt="banner" src={source ?? bannersUrl[name]} />
    </Card>
  );
}
